import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=0690d79c&scoped=true"
import script from "./PricingPage.vue?vue&type=script&lang=js"
export * from "./PricingPage.vue?vue&type=script&lang=js"
import style0 from "./PricingPage.vue?vue&type=style&index=0&id=0690d79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690d79c",
  null
  
)

export default component.exports